export default __webpack_public_path__ + "static/media/4T0A9570.c696d0cb.jpg";